import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import './index.css';

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const savedUser = localStorage.getItem('invoiceUser');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const handleLogin = (userData) => {
    localStorage.setItem('invoiceUser', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('invoiceUser');
    setUser(null);
  };

  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div className="app-container">
      <nav className="dashboard-nav no-print">
        <div className="brand">
          <img src="https://intechronix.com/images/logo.svg" alt="Intechronix Logo" style={{ height: '32px' }} />
          InvoiceSystem
        </div>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          <span style={{ fontWeight: '500' }}>{(user.role || user.Role) === 'SuperAdmin' ? 'Admin Panel' : (user.companyName || user.CompanyName)}</span>
          <button onClick={handleLogout} className="btn-outline" style={{ padding: '0.4rem 1rem' }}>Logout</button>
        </div>
      </nav>
      
      <main className="premium-container">
        <Dashboard user={user} />
      </main>
    </div>
  );
}

export default App;
